import { render, staticRenderFns } from "./BookingsSlot.vue?vue&type=template&id=3df454ce&scoped=true&"
import script from "./BookingsSlot.vue?vue&type=script&lang=js&"
export * from "./BookingsSlot.vue?vue&type=script&lang=js&"
import style0 from "./BookingsSlot.vue?vue&type=style&index=0&id=3df454ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df454ce",
  null
  
)

export default component.exports